import { gql } from "@apollo/client";

export const GET_ACTIVE_SYSTEMS = gql`
  query ActiveWaterSystemRatingsCount {
    getActiveWaterSystemRatingsCount {
      name
      value
    }
  }
`;

export const GET_COMMUNITY_POP_SERVED = gql`
  query CommunityWaterSysCountByPopServed {
    getCommutnityWaterSystsemCountsByPopulationServed {
      name
      value
    }
  }
`;

export const GET_SYS_SIZE_POP_SERVED = gql`
  query SysSizePopStats {
    getPopulationBySystemSizeStats {
      value
      name
    }
  }
`;

export const GET_ACTIVE_SYS_TYPE = gql`
  query ActiveSysTypeStats {
    getSystemByTypeStats {
      value
      name
    }
  }
`;

export const GET_POP_SERVED_BY_WATERSYS_RATING = gql`
  query CommPopStats {
    getCommutnityWaterSystsemCountsByPopulationServed {
      value
      name
    }
  }
`;

export const GET_WATER_SOURCE_NO_LOCATION_DATA = gql`
  query CommPopStats {
    getSourceWithoutLocationStats {
      value
      name
    }
  }
`;

export const GET_EPA_HEALTH_STATS = gql`
  query EPAHeathReq($fromDate: Date, $toDate: Date) {
    getEpaHealthCounts(fromDate: $fromDate, toDate: $toDate) {
      EpaViolationCounts {
        violationType
        individualViolation
        system
        totalPopulation
        eachInstancePopulation
      }
      EpaHealthCalcs {
        name
        affectedCnt
        totalCnt
        standard
        actualPercent
        targetPercent
      }
    }
    getFormalEnforcementActions(fromDate: $fromDate, toDate: $toDate) {
      value
      name
    }
  }
`;
